<template>
    <div class="time-column" 
        :class="{
            'time-column-narrow': isNarrowColumn,
            'hidden': hidden,
            'grid': VIEW_MODES.grid == selectedViewMode,
        }">
        <!--
        <span class="resource-title">{{ table.title }}</span>
        -->
        <div class="time-block" 
            v-for="(block, index) in table.timeBlocks" :key="index"
            @click="reserveBlock({ index, table })"
            :style="blockStyle(block)"
            :class="{
                'past': block.past,
                'disabled': !block || [2,9,12].includes(block.type),
                'start-enabled': block.isStartingPoint,
                'start-disabled': block.type === 10,
                //'reservation-too-close': [3,4].includes(block.type) && false,
                'reserved': [1,6,7].includes(block.type),
                'reserved-resellable': block.type === 11,
                'reserved-issellable': block.isSellable,
                'reserved-issharereservation': block.isShareReservation,
                'reserved-isrecurring': block.isRecurring,
                'reserved-issold': block.isSold,
                'reserved-isuserreservation': block.isUserReservation && ![2,9].includes(block.type),
                'reserved-paymentdelayed': block.paymentDelayed && adminMode,
                'reserved-cart': [7].includes(block.type) && adminMode,
                'reserved-partlypaid': block.partlyPaid && adminMode,
                'disallowed': [8].includes(block.type) && !adminMode, 
                'hidden': block.hide,
            }"
            :title="block.info">
            <div class="timeblock-inner">
                <div class="icon-left" v-if="hasComments(block)">
                    <span class="glyphicon glyphicon-info-sign"></span>
                </div>
                <span class="title title-classic">{{ block.title }}</span>
                <span class="title title-modern">
                    <template v-if="[2,9].includes(block.type) || ([7].includes(block.type) && adminMode)">
                        {{ block.info }}
                    </template>
                    <template v-else>
                        {{ block.title }}    
                    </template>                    
                </span>
                <div class="availibility-indicator" v-if="[5].includes(block.type)">
                    ({{ block.availableQuantity }})
                </div>
                <div class="icon-right" v-if="[3,4].includes(block.type)">
                    <span class="glyphicon glyphicon-alert"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['table','hidden'],
    data: () => ({
        narrowColumn: false,
    }),
    computed: {
        ...mapGetters({
            selectedViewMode: 'calendar/selectedViewMode',
            VIEW_MODES: 'calendar/VIEW_MODES',
            reviewBlock: 'calendar/reviewBlock',
            loggedIn: 'common/loggedIn',
            requireLoggedIn: 'common/requireLoggedIn',
            mobile: 'common/mobile',
            admin: 'common/admin',
            adminMode: 'common/adminMode',
            settings: 'reservations/settings',
            minuteRules: 'reservations/minuteRules',
            additionalResources: 'reservations/additionalResources',
            generateReservation: 'reservations/generateReservation',
            resourceCommentsByBlock: 'reservations/resourceCommentsByBlock',
            TIMEBLOCK_TYPE: 'reservations/TIMEBLOCK_TYPE',
            isEmbed: 'common/isEmbed',
        }),
        isNarrowColumn() {
            const narrowColumn = this.narrowColumn;

            if (this.mobile) {
                return false;
            }

            return narrowColumn;
        },
        hasComments() {
            return (block) => this.resourceCommentsByBlock(block).length > 0;
        },
    },
    methods: {
        blockStyle(block) {
            /**
             * TODO: grid/rows views from golf view
             * when these are used, no top positioning or height
             * VIEW_MODES.grid == selectedViewMode
             * VIEW_MODES.rows != selectedViewMode
             * else:
             */
            if (this.selectedViewMode === this.VIEW_MODES.grid) {
                return {};
            }
            
            return {
                height: `calc(var(--time-base-pixel) * ${ block.height })`,
                top: `calc(var(--time-base-pixel) * ${ block.top })`
            }
        },
        reserveBlock(data) {
            let { index, table } = data;
            let config = {};
            const TIMEBLOCK_TYPE = this.TIMEBLOCK_TYPE;
            
            if (!this.loggedIn && this.requireLoggedIn) {
                return this.$_swal({
                    title: this.$_locale('you have to be logged in to reserve'),
                    text: '',
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonClass: 'btn-default',
                    confirmButtonClass: 'btn-warning',
                    confirmButtonText: this.$_locale('Login'),
                    cancelButtonText: this.$_locale('cancel')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        setTimeout(() => {
                            if (this.isEmbed) {
                                const postData = {
                                    type: 'login',
                                }
                                
                                window.top.postMessage(JSON.stringify(postData), '*');
                            } else {
                                document.querySelector('#loginModalLink').click()
                            }
                        }, 350);
                    } else {
                        
                    }
                })
            }
            
            const block = table.timeBlocks[index]

            if (this.minuteRules.length && block.type === TIMEBLOCK_TYPE.endTooClose) {
                if (block.info.length > 0) {
                    this.$_swal({ icon: 'error', title: block.info })
                }
                return;
            }
            
            if (!this.reviewBlock(data)) {
                let showReservationModal = false;
                if (this.adminMode && ![TIMEBLOCK_TYPE.disabledByRule, TIMEBLOCK_TYPE.noDurationFits].includes(block.type)) {
                    // - check if block resource has quantity > 1
                    // - list all reservations on a block in a modal and then select a reservation to editReservation variable
                    if (block.resource.quantity > 1) {
                        const reservation = this.generateReservation(index, table);
                        this.$store.commit('calendar/setActiveReservation', reservation)
                        this.$store.commit('common/setModal', 'listreservations')
                    } else if (block.reservations.length && block.reservations[0].status != 6) {
                        const reservation = block.reservations[0]

                        this.$store.dispatch('calendar/setEditReservation', { block, reservation })
                    }
                } else if (block.type === TIMEBLOCK_TYPE.startDisabled) {
                    if (this.reviewBlock({ index: index - 1, table })) {
                        index -= 1;
                        showReservationModal = true;
                    } else {
                        if (block.info.length > 0) {
                            this.$_swal({ icon: block.type !== TIMEBLOCK_TYPE.reservation ? 'error' : 'success', title: block.info })
                        }
                    }
                } else {
                    if (block.info.length > 0) {
                        this.$_swal({ icon: block.type !== TIMEBLOCK_TYPE.reservation ? 'error' : 'success', title: block.info })
                    }
                }

                if (!this.adminMode) {
                    const [ reservation ] = block.reservations

                    if (this.settings.enableResell 
                        && reservation
                        && reservation.isUserReservation 
                        && reservation.isSellable
                        && !reservation.isCart) {                    
                        this.$store.commit('calendar/setEditReservation', { block, reservation })
                        this.$store.commit('common/setModal', 'userreservationdisplay')

                        return false;
                    }
                }

                if (this.settings.enableResell 
                    && block.reservations[0]?.status == 6) {
                    const {
                        reservationTimeId, 
                        start, 
                        end,
                        label,
                        shareId
                    } = block.reservations[0];
                    config = {
                        soldReservationTimeId: reservationTimeId,
                        start, 
                        end,
                        label,
                        shareId
                    };
                    
                    showReservationModal = true;
                    index = table.timeBlocks.findIndex(
                        row => row.start.format('YYYY-MM-DD HH:mm:ss') === start
                    )
                }

                if (!showReservationModal) {
                    return false;
                }
            }
            //console.log('reserveBlock', index, table);
            const reservation = this.generateReservation(index, table, config);
            
            this.$store.commit('calendar/setActiveReservation', reservation)
            this.$store.commit('common/setModal', 'reservation')
            
            if (Array.isArray(this.additionalResources) 
                && this.additionalResources.length > 0) {
                this.$store.dispatch('calendar/updateAvailableAdditionalResources', true)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            const { width } = this.$el.getBoundingClientRect();

            if (width < 95) {
                this.narrowColumn = true;
            }
            //console.log('timeColumn', JSON.stringify(this.$el.getBoundingClientRect()), width < 95)
        })
    }
}
</script>

<style scoped>
/* this should be in bootstrap but it is what it is */
.reservation-table .time-block .timeblock-inner .icon-left {
    position: absolute;
    left: 7px;
}
</style>